module.exports = __webpack_public_path__ + "static/media/dreidel.91492bc7.svg";